import { useEffect, useState } from 'react';
import { EFormType, IForm } from '../../models/form/form';
import { Box } from '@mui/system';
import FormService from '../../services/form/FormService';
import DataTable from '../../components/table/data/DataTable';
import { useNavigate } from 'react-router-dom';
import { useFormColumns } from '../../hooks/useTableColumns';
import moment from 'moment';
import localService from '../../services/local/LocalService';
import buildingService from '../../services/building/BuildingService';
import propertyGroupService from '../../services/propertyGroupService/PropertyGroupService';
import userService from '../../services/user/UserService';


const FilledFormsPage = () => {
  const navigate = useNavigate();
  const [forms, setForms] = useState<IForm[]>([]);
  const columns = useFormColumns();

  useEffect(() => {
    FormService.GetFilledForms().then(async (forms) => {
      const locals = await localService.GetLocalsByCompany()
      const buildings = await buildingService.GetBuildingsDetails()
      const propertyGroups = await propertyGroupService.GetPropertyGroups();
      const users = await userService.GetUsersByCompany();

      const newForms = forms.map((form) => {
        const localDetail = locals.find((localDetail) => localDetail.local.id === form.localId)
        const building = localDetail?.building
        const floor = localDetail?.floor
        const local = localDetail?.local
        const propertyGroup = propertyGroups.find((propertyGroup) => propertyGroup.id === form.propertyGroupId || propertyGroup.id === building?.propertyGroupId)

        const user = users.find((user) => user.id === form.userId)

        return { ...form, building: building, floor: floor, local: local, propertyGroup: propertyGroup, user: user }
      }).sort((a, b) => moment(b.date).diff(moment(a.date)));

      setForms(newForms)

    })
  }, []);


  return (

    <Box sx={{ width: "100%", height: "100%" }}>
      <DataTable
        dense
        rows={forms}
        columns={columns}
        onRowClick={(row) =>
          navigate(`${row.id}`, { state: { ...row } })
        }
        getRowNavTo={(row) => `${row && row.id}`}
      />
    </Box>
  );
};
export default FilledFormsPage;
